import { repository, baseURL } from '@/api/base'
import download from '@/plugins/download'
import { getAnnualReportName, getReportForWorkName } from '@/scripts/report'

export default {
  async reportForWork(body, employeeName) {
    const { data } = await repository.post(baseURL + '/xlsx/reportForWork', body, { responseType: 'blob' })
    data && download(data, getReportForWorkName(body, employeeName))
  },

  async reportDisMember(periodId) {
    const { data } = await repository.get(baseURL + `/xlsx/reportDisMember/${periodId}`, { responseType: 'blob' })
    data && download(data, 'Распределение баллов по участникам дисс. советов.xlsx')
  },

  async reportPublicaton(body) {
    const { data } = await repository.post(baseURL + '/xlsx/reportPublicaton', body, { responseType: 'blob' })
    data && download(data, 'Отчет по публикациям.xlsx')
  },

  async annualReport(body) {
    const { data } = await repository.post(baseURL + '/xlsx/annualReport', body, { responseType: 'blob' })
    data && download(data, getAnnualReportName(body))
  }
}
